import {  TestTube01Icon, Message01Icon, Book02Icon } from "hugeicons-react";
import "../../Styles/Layout/AuthBox.css";
import { useAuth } from "../../contexts/AuthContext";
import { useState, useEffect } from "react";
import { LoginButton } from "../Auth/Buttons/LoginButton";
import { SignUpButton } from "../Auth/Buttons/SignUpButton";
import { AttachmentDropIcons } from "../../assets/svg/AttachmentDropIcons";

export const AuthBox: React.FC = () => {
  const auth = useAuth();
  const [isOpen, setIsOpen] = useState(!auth.isAuthenticated && !auth.isLoading);

  useEffect(() => {
    if(!auth.user){
      setIsOpen(!auth.isAuthenticated && !auth.isLoading && (auth.chatUsageData?.remaining ?? 0) <= 0);
    } else {
      setIsOpen(false);
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.chatUsageData, auth.user]);



  if (!isOpen) {
    return null;
  }

  return (
    <div className="auth-box">
      <div className="auth-box-content">
        <div className="auth-box-header">
          <h3>Sign In to Unlock Full Access</h3>
          <p>Explore the complete range of features:</p>
        </div>
        <div className="auth-box-main">
          <ul className="auth-box-features">
            <li><Book02Icon size={16} strokeWidth={2}/> Generate Resources</li>
            <li><Message01Icon size={16} strokeWidth={2}/> Get Up to Date News</li>
            <li><TestTube01Icon size={16} strokeWidth={2}/> Create Quizzes Instantly</li>
          </ul>
          <div className="auth-box-visual">
            <AttachmentDropIcons size={130} />
          </div>
        </div>
        <div className="auth-box-actions">
          <SignUpButton />
          <LoginButton />
        </div>
      </div>
    </div>
  );
};